import React from 'react';

const NIcon = () => {
  return (
    <svg
      className="n-icon-wide"
      width="179"
      height="72"
      viewBox="0 0 179 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2834_2294)">
        <path
          d="M115.731 0V28.1606L63.6703 0H0V72H63.6703V43.6334L115.731 72H179V0H115.731Z"
          fill="#FFBF80"
        />
      </g>
      <defs>
        <clipPath id="clip0_2834_2294">
          <rect width="179" height="72" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NIcon;
